import './List.scss';

export const List = ({requiredColumns = [], additionalColumns = [], clientColumns = [], data, renderCell, onClick}) => {

    return (
        <div className={"list"}>
            <ul className={"list_container"}>
                {data.map((row, rowIndex) => (
                    <li className={"list_item"} key={`row-${rowIndex}`} onClick={() => onClick?.(row, rowIndex)}>
                        {requiredColumns.map((column, index) => (
                            <div className={"list_row"} key={`header-${rowIndex}-${index}`}>
                                <div className={"list_header"}>
                                    {row[column.key]}
                                </div>
                            </div>
                        ))}
                        {clientColumns.map((column, index) => (
                            <div className={"list_row"} key={`middle-${rowIndex}-${index}`}>
                                <div className={"list_title"}>
                                    {column.header}
                                </div>
                                <div className={"list_value"}>
                                    {row[column.key]}
                                </div>
                            </div>
                        ))}
                        {additionalColumns.map((column, index) => (
                            <div className={"list_row"} key={`header-${rowIndex}-${index}`}>
                                <div className={"list_value"}>
                                    {renderCell ? renderCell(column.key, row[column.key], row) : row[column.key]}
                                </div>
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        </div>
    )
}